<template>
  <v-sheet :height="this.$root.windowHeight">
    <v-container class="fill-height">
      <v-col align="center">
      <v-row justify="center" align="center" class="mb-3">
        <h1>¡Gracias por este {{$route.params['year']}}!</h1>
      </v-row>
        <v-row justify="center" align="center" class="mb-6">
          <h4 class="font-weight-light">Toca el link para copiar</h4>
        </v-row>
      <v-row justify="center" align="center">
        <v-text-field
            class="centered-input"
            color="#00766c"
            :append-icon="copied ? 'mdi-check': 'mdi-content-copy'"
            @click="copyLink"
            v-model="link"
            filled
            readonly
            outlined
        ></v-text-field>
      </v-row>
      </v-col>
    </v-container>
  </v-sheet>

</template>

<script>
export default {
  name: "ShareLink",
  data: () => ({
    copied: false,
    link: '',
  }),
  methods: {
    copyLink() {
      this.copied = true;
      navigator.clipboard.writeText(this.link);
    }
  },
  mounted() {
    this.link = window.location.origin + this.$route.path
  }
}
</script>

<style scoped>
  .centered-input >>> input {
    text-align: center;
  }
</style>
